import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import App from './App.jsx';
import './index.css';

// Initialize Sentry for error tracking
Sentry.init({
  dsn: "https://965424e6dc36ac9c5a7f011063c5426c@o4510608231432192.ingest.us.sentry.io/4510608237002752",

  // Enable integrations
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],

  // Environment detection
  environment: import.meta.env.MODE,

  // Capture 100% of errors
  sampleRate: 1.0,

  // Performance monitoring (10% of transactions)
  tracesSampleRate: 0.1,

  // Session replay - capture 10% of sessions, 100% on error
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,

  // Send default PII data (IP address, etc.)
  sendDefaultPii: true,
});

// Expose Sentry globally for console testing
window.Sentry = Sentry;

const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID || '';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <Sentry.ErrorBoundary
        fallback={({ error, resetError }) => (
          <div className="min-h-screen bg-slate-900 flex items-center justify-center p-4">
            <div className="bg-slate-800 border border-slate-700 rounded-2xl p-8 max-w-md text-center">
              <h1 className="text-2xl font-bold text-white mb-4">Something went wrong</h1>
              <p className="text-slate-400 mb-6">
                We've been notified and are working on a fix. Please try refreshing the page.
              </p>
              <button
                onClick={() => window.location.reload()}
                className="px-6 py-3 bg-indigo-600 text-white rounded-lg font-semibold hover:bg-indigo-500 transition-colors"
              >
                Refresh Page
              </button>
            </div>
          </div>
        )}
        onError={(error) => {
          console.error('Caught by Sentry ErrorBoundary:', error);
        }}
      >
        <App />
      </Sentry.ErrorBoundary>
    </GoogleOAuthProvider>
  </React.StrictMode>
);
